// import ls from '@/helpers/localStorage/index';
// import config from '@/helpers/config/index';

const state = {
  events: [],
  selected: null,
  isLoading: false,
  newEventsBuffer: false,
  notificationEvents: 0,
  newEvents: {
    eventTitle: '',
    eventPublishTime: '',
    eventImportance: '',
    eventMeter: '',
    eventCategory: '',
    eventMagnitude: ''
  },
  options: {
    query: '',
    page: 1,
    lastTimestamp: 0,
    startTime: '',
    endTime: '',
    sort: '',
    eventStatus: ['Published'],
    initial: true
  },
  filters: {
    importance: {
      critical: false,
      warning: false,
      information: false
    },
    scope: {
      local: true,
      national: true,
      global: true
    },
    magnitude: {
      low: false,
      medium: false,
      high: false
    },
    veracity: {
      low: false,
      medium: false,
      high: false
    },
    customLocations: [],
    locations: [],
    categories: [],
    regions: [],
    keywords: []
  },
  returns: 0,
  index: 0,
  autoCompleteLoading: false,
  endOfList: false,
  entries: [],
  dateNow: 0,
  nextEventTimer: 1000 * 14, //14 seconds
  nextEventTimeOut: null,
  advance: false,
  environment: 'staging'
};

const getters = {
  events(state) {
    return state.events;
  },
  newEvents(state) {
    return state.newEvents;
  },
  newEventsBuffer(state) {
    return state.newEventsBuffer;
  },
  selected(state) {
    return state.selected;
  },
  isLoading(state) {
    return state.isLoading;
  },
  returns(state) {
    return state.returns;
  },
  index(state) {
    return state.index;
  },
  autoCompleteLoading(state) {
    return state.autoCompleteLoading;
  },
  entries(state) {
    return state.entries;
  },
  getDate(state) {
    return state.dateNow;
  },
  eventsGetEndOfList(state) {
    return state.endOfList;
  },
  eventsGetNotification(state) {
    return state.notificationEvents;
  },
  eventsGetAdvance(state) {
    return state.advance;
  }
};

const mutations = {
  setReturns(state, returns) {
    state.returns = state.returns + returns;
  },
  setInitialReturns(state, returns) {
    state.returns = state.events.length + returns;
  },
  mergeEvents(state, events) {
    state.newEventsBuffer = true;
    events.reverse().forEach(e => {
      let index = state.events.findIndex(event => event._id === e._id);
      if (index === -1) {
        ++state.index;
        state.newEvents = {
          eventTitle: e._source.eventTitle,
          eventPublishTime: e._source.eventPublishTime,
          eventImportance: e._source.eventImportance,
          eventMeter: e._source.meter,
          eventCategory: e._source.eventCategory,
          eventMagnitude: e._source.magnitude
        };
        state.events.unshift(e);
      }
    });
    setTimeout(() => {
      state.newEventsBuffer = false;
      state.newEvents = {
        eventTitle: '',
        eventPublishTime: '',
        eventImportance: '',
        eventMeter: '',
        eventCategory: '',
        eventMagnitude: ''
      };
      state.dateNow = new Date().getTime();
    }, 6000);
  },
  clearEvents(state) {
    state.events = [];
    state.returns = 0;
  },
  clearQuery(state) {
    state.url = '';
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  select(state, index) {
    if (state.events[index].hasOwnProperty('new') && state.events[index].new) {
      state.events[index].new = false;
    }
    state.notificationEvents = 0;
    state.events.forEach(event => {
      if (event.hasOwnProperty('new') && event.new) {
        state.notificationEvents++;
      }
    });
    state.selected = state.events[index];
  },
  updateSelector(state, index) {
    state.index = index;
  },
  autoCompleteLoading(state, loading) {
    state.autoCompleteLoading = loading;
  },
  updateEntries(state, response) {
    state.entries = response;
  },
  eventsClearEntries(state) {
    state.entries = [];
  },
  nextEvent(state) {
    ++state.index;
    state.selected = state.events[state.index];
  },
  setNewCurrentTime(state) {
    state.dateNow = new Date().getTime();
  },
  eventsToggleEndOfList(state, bool) {
    state.endOfList = bool;
  },
  eventsCheckAdvance(state) {
    if (
      state.options.query !== '' ||
      state.options.startTime !== '' ||
      state.options.endTime !== '' ||
      state.filters.locations == [] ||
      state.options.eventCategory == []
    ) {
      state.advance = true;
    } else {
      state.advance = false;
    }
  }
};

const actions = {
  eventSetInitialEvents(context, events) {
    events.forEach(event => {
      if (context.state.events.findIndex(currentEvent => currentEvent._id === event._id) === -1) {
        context.state.events.push(event);
      }
    });
  },
  eventSetEvents(context, events) {
    events.forEach(event => {
      if (context.state.events.findIndex(currentEvent => currentEvent._id === event._id) === -1) {
        context.state.notificationEvents++;
        context.state.events.unshift(Object.assign({ new: true }, event));
      }
    });
    context.dispatch('generalFollowEventsChecker');
  },
  search(context, options) {
    if (context.state.isLoading) {
      return;
    }
    // clear items first
    // console.log('initial', options.initial)
    context.commit('clearEvents');
    context.commit('updateSelector', 0);
    context.state.endOfList = false;
    context.state.notificationEvents = 0;

    // apply options and filters to store
    context.state.options.query = options.query || '';
    // context.state.options.query =
    //   'pneumonia strain quarantined cv-19 wuhan corona covid coronavirus flu virus hubei influenza positive quarantine nCoV infection infections covid19';
    context.state.options.page = 0;
    context.state.options.lastTimestamp = 0;
    context.state.options.startTime = options.startTime || '';
    context.state.options.endTime = options.endTime || '';
    context.state.options.eventCategory = options.categories || [];
    context.state.options.importance = options.importance || [];
    context.state.options.sort = 'timestamp+desc';
    context.state.options.eventStatus = ['Published'];
    // context.state.filters.categories = ['Plc', 'Hlt', 'Plt', 'Mny'];
    context.state.filters.importance.critical = options.eventImportance.includes('Critical');
    context.state.filters.importance.warning = options.eventImportance.includes('Warning');
    context.state.filters.importance.information = options.eventImportance.includes('Information');
    context.state.filters.locations = options.locationCode || [];
    context.state.options.initial = options.initial;
    context.state.advance = options.advance;

    // and then load
    context.commit('eventsCheckAdvance');
    context.dispatch('eventsLoad', false);
  },
  eventsLoad(context, getMore) {
    context.commit('setIsLoading', true);
    context
      .dispatch('serverRequest', {
        action: 'viruswatch/event-retrieve',
        data: {
          options: context.state.options,
          filters: context.state.filters,
          user: 'default',
          channel: 'all',
          environment: context.state.environment
        }
      })
      .then(response => {
        // console.log(response);
        context.dispatch('eventSetInitialEvents', response.data.events.hits.hits);
        context.commit('select', context.state.index);
        context.commit('setInitialReturns', response.data.events.hits.total);
        if (getMore) {
          if (response.data.events.hits.hits.length == 0 && !context.state.endOfList) {
            context.state.endOfList = true;
          }
        }
      })
      .catch(() => {
        // console.log(err);
        context.commit('setIsLoading', false);
      })
      .finally(() => {
        context.commit('setIsLoading', false);
        context.state.dateNow = new Date().getTime();
      });
  },
  eventsNextPage(context) {
    if (context.state.isLoading || context.state.endOfList) {
      return;
    }
    let lastTimestamp = 0;
    context.state.events.length === 0 ||
      (lastTimestamp = parseInt(context.state.events[context.state.events.length - 1]._source.eventPublishTime, 10));
    !isNaN(lastTimestamp) || (lastTimestamp = 0);
    context.state.options.lastTimestamp = lastTimestamp;
    context.state.options.sort = 'timestamp+desc';
    context.state.options.initial = true;
    context.state.endOfList = false;
    context.dispatch('eventsLoad', true);
  },
  eventsLoadPull(context) {
    context.commit('setIsLoading', true);
    if (context.state.events.length !== 0) {
      if (context.state.options.startTime.length == 0) {
        context.state.options.startTime = context.state.events[0]._source.eventPublishTime + 10;
      }
    }
    context.state.options.sort = 'timestamp+asc';
    context
      .dispatch('serverRequest', {
        action: 'viruswatch/event-retrieve',
        data: {
          options: context.state.options,
          filters: context.state.filters,
          user: 'default',
          channel: 'all',
          environment: context.state.environment
        }
      })
      .then(response => {
        // console.log(response);
        context.dispatch('eventSetEvents', response.data.events.hits.hits);
        context.commit('setReturns', response.data.events.hits.total);
      })
      .catch(() => {
        // console.log(err);
        context.commit('setIsLoading', false);
      })
      .finally(() => {
        context.commit('setIsLoading', false);
        context.state.dateNow = new Date().getTime();
      });
  },
  autoComplete(context, search) {
    context.commit('autoCompleteLoading', true);
    context
      .dispatch('serverRequest', {
        action: 'auto-complete',
        data: {
          query: search,
          limit: 5
        }
      })
      .then(response => {
        // console.log(response);
        context.commit('updateEntries', response.data.autoComplete);
      })
      .catch(err => console.log(err))
      .finally(() => context.commit('autoCompleteLoading', false));
  },
  select(context, index) {
    context.commit('select', index);
    context.commit('updateSelector', index);
    if (index >= context.state.events.length / 2) {
      context.dispatch('eventsNextPage');
    }
  },
  eventsInitFollowEvents(context) {
    let initialIndex = context.state.events.findIndex(events => events._id === context.state.selected._id);
    if (initialIndex !== 0) {
      let counter = 0;
      let checker = true;
      let newEvents = -1;
      while (checker) {
        if (state.events[counter].hasOwnProperty('new') && state.events[counter].new) {
          newEvents = newEvents + 1;
          counter = counter + 1;
        } else {
          checker = false;
          break;
        }
      }
      if (newEvents !== -1) {
        context.dispatch('eventsFollowEvents', newEvents);
      }
    }
  },
  eventsFollowEvents(context, index) {
    if (index !== -1) {
      context.state.nextEventTimeOut = setTimeout(() => {
        context.dispatch('select', index);
        context.dispatch('eventsFollowEvents', index - 1);
      }, context.state.nextEventTimer);
    } else {
      clearTimeout(context.state.nextEventTimeOut);
    }
  },
  // serverAfterConnect(context) {
  //   // console.log(config);
  //   context
  //     .dispatch('serverRequest', {
  //       action: 'auth/okta-session',
  //       // action: 'okta-session',
  //       data: {
  //         user: { email: 'client-wuhan-flatmap' },
  //         version: 'v1.0'
  //       }
  //     })
  //     .then(response => {
  //       if (response.success) {
  //         context.dispatch('eventsLoad');
  //       } else {
  //         console.log('Failed oktaAuthentication');
  //       }
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       context.dispatch('serverAfterConnectBackup');
  //     });
  // },
  serverAfterConnect(context) {
    // console.log(config);
    context
      .dispatch('serverRequest', {
        // action: config.environmnet === 'production' ? 'okta-session' : 'auth/okta-session',
        action: 'auth/okta-session',
        data: {
          user: { email: 'client-wuhan-flatmap' },
          version: 'v1.0'
        }
      })
      .then(response => {
        if (response.success) {
          context.dispatch('eventsLoad');
        } else {
          console.log('Failed oktaAuthentication');
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
